













import { Component, Emit, Prop } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'

@Component
export default class AtomChipButton extends ComponentVue {
  @Prop({
    type: Boolean,
    default: false
  })
  primary!: boolean

  @Prop({
    type: Boolean,
    default: false
  })
  disabled!: boolean

  get color(): string {
    return this.primary ? 'primary' : ''
  }

  @Emit('click')
  onClick(): void {}
}
